var lib_core = require("lib-core");
var SwitcherItemModel = require('./switcherItemModel.js');

var SwitcherModel = function (dataRoot, tmpConfig, collection, realConfig) {
    var self = this;
    lib_core.Model.call(this);

    this.tmpConfig = tmpConfig;
    this.realConfig = realConfig;
    this.collection = collection;
    this.visible = this.value("visible", true);
    this.dataRoot = dataRoot;
    this.items = this.list("items", true);
    this.selectedItem = this.value("selectedItem", false);   // TODO: change into selection when multiple switcher elements can be selected

    this.selectedItem.onChange("setSelected", function(value, old){
        if(value && value.isJson){
            value.dejsonifyItem(self.dataRoot, self.collection);
        }
        if(old) old.selected(false);
        if(value) value.selected(true);
    });

    this.items.onAdd(this, function(idx, val) {
        if(self.items.size() == 1 ) {    //first item added
            if(!self.realConfig.hidden) self.visible(true);
            self.selectedItem(self.items.get(0));
        }
    });

    this.items.onRemove(this, function(idx, val) {
        if(self.items.size() > 0) {
            self.selectedItem(self.items.get(0));
        } else {
            self.visible(false);
        }
    });

    this.collection.onAdd(this, function(idx, data){
        var switcherItemModel = new SwitcherItemModel(data, 0, tmpConfig);
        self.items.add(idx, switcherItemModel);
    });

    this.collection.onRemove(this, function(idx, data){
        self.items.remove(idx);
    });
    // TODO add onSwap handler: when items in collection changed positions, IM needs to be updated as well

    if(this.realConfig.hidden)
        this.visible(false);

    this.items.onBubble(this, function(){
       if (self.selectedItem() && !self.selectedItem().isAlive()) self.selectedItem(null);
    });

    this.onInit("init", this.initialize);
};

lib_core.inherit(SwitcherModel, lib_core.Model);
SwitcherModel.$class = "SwitcherModel";

module.exports = SwitcherModel;

// data = self.dataRoot.dejsonify(data);
// data.root = self.dataRoot;

SwitcherModel.prototype.initialize = function() {
    var self = this;
    this.collection.forEach(function(idx, data){
        var isJson = (data.isObservableTreeNode) ? false: true;
        var switcherItemModel = new SwitcherItemModel(data, 0, self.tmpConfig, isJson);
        self.items.add(idx, switcherItemModel);
    });

    this.selectedItem(this.items.get(0));

    if(!this.realConfig.hidden)
        self.visible(self.items.size() > 0);
};

SwitcherModel.prototype.deleteSelection = function() {
    if (this.selectedItem() != null && !this.realConfig.canNotEdit){
        this.selectedItem().remove();
    }
};

SwitcherModel.prototype.selectData = function(data) {
    var found = null;
    this.items.forEach(function(i, item){
        found = found || item.searchData(data);
    });

    if (found) this.selectedItem(found);
};
